import { createStackNavigator } from "@react-navigation/stack"
import { ContactSurveyAnswerStackParamList } from "src/types.d"

export const ContactSurveyAnswerStack = createStackNavigator<ContactSurveyAnswerStackParamList>()
